import { TabList as ReachTabList, Tabs as ReachTabs } from '@reach/tabs'
import cx from 'classnames'
import * as React from 'react'

import styles from './tab-bar.module.scss'

export type Props = {
  index?: number
  children: React.ReactNode
  onChange?: (arg0: number) => void
  className?: string
}

export default function TabBar(props: Props) {
  const { children, onChange, className, index } = props

  return (
    <ReachTabs
      index={index}
      className={cx(styles.tabBar, className)}
      onChange={onChange}
    >
      <ReachTabList className={styles.tabList}>{children}</ReachTabList>
    </ReachTabs>
  )
}
